import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { closeEditPerson } from 'reducers/DialogsReducer';
import Dialog from 'components/Dialog';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { handleError } from 'reducers/ErrorReducer';
import ContactMethods from './ContactMethods';
import Credential from './Credential';
import Employment from './Employment';
import PersonTab from 'Dialogs/AddPersonDialog/PersonTab';
import PersonAssociate from './PersonAssociate';
import Features from './Features';
import Names from './Names';
import PersonVehicle from './PersonVehicle';
import Addresses from './Addresses';
import Sops from './Sops';
import Attachments from 'components/Attachments';
import DnaSamples from './DnaSamples';
import Photo from './Photo';
import RelatedRecords from './RelatedRecords';
import Bulletins from './Bulletins';
import { getPeopleSops } from 'reducers/SearchReducer';
import { findBulletinsData } from 'reducers/BulletinReducer';
import { getFullPermissions } from 'reducers/PermissionsReducer';

const useStyles = makeStyles((theme) => ({
  wrap: {
    padding: theme.spacing(3),
  },
  content: {
    margin: -theme.spacing(3),
  },
  RedTabs: {
    color: 'red',
  },
}));

function Person(props) {
  const classes = useStyles();
  const { person } = props;
  const { ptsPersonID } = person;
  const [tab, setTab] = useState('edit');
  const mountedRef = useRef(true);
  const newPerson = !ptsPersonID;
  const [countOfSops, setCountOfSops] = useState(0);
  const [countOfBulletin, setCountOfBulletin] = useState(0);
  const permissions = getFullPermissions('globals', 'People', 'any');

  useEffect(() => {
    if (props.tab) setTab(props.tab);
    if (!newPerson) {
      getSOPAndBulletinNumber();
    }
    return () => {
      mountedRef.current = false;
    };
    // eslint-disable-next-line
  }, [props.tab]);

  const close = (data) => {
    props.closeEditPerson(data);
  };

  const getSOPAndBulletinNumber = async () => {
    try {
      await Promise.all([getSOPs(), getBulletins()]);
    } catch (err) {
      props.handleError(err, 'Error loading SOPs or bulletins.');
    }
  };

  const getSOPs = async () => {
    try {
      const sops = await getPeopleSops(ptsPersonID);
      if (!mountedRef.current) return;
      setCountOfSops(processSOPData(sops.data).length);
    } catch (err) {
      props.handleError(err, 'Error receiving person sops data.');
    }
  };

  const getBulletins = async () => {
    try {
      const bulletins = await findBulletinsData({ ptsPersonID: ptsPersonID });
      if (!mountedRef.current) return;
      setCountOfBulletin(processBulletinData(bulletins).length);
    } catch (err) {
      props.handleError(err, 'Error receiving person bulletins data.');
    }
  };

  const processBulletinData = (data) => {
    return data.map((row) => ({ ...row, id: row.ptsAlertID }));
  };

  const processSOPData = (data) => {
    return data.map((row, idx) => {
      return { ...row, id: idx };
    });
  };

  const handleSOPChange = (newCount) => {
    setCountOfSops(newCount);
  };

  const handleBulletinChange = (newCount) => {
    setCountOfBulletin(newCount);
  };

  return (
    <Dialog
      toolbar
      onClose={close}
      title={
        newPerson ? (
          'Add Person'
        ) : permissions.Edit ? (
          'Edit Person'
        ) : (
          <div
            className="d-flex"
            style={{ width: '100%', justifyContent: 'left', textAlign: 'left' }}>
            <span style={{ flex: 0.5 }}></span>
            <span style={{ flex: 0.5, color: 'red', fontWeight: 'bold', fontSize: '21px' }}>
              VIEW ONLY MODE
            </span>
          </div>
        )
      }
      fullScreen>
      <div className={classes.content}>
        <Paper square>
          <Tabs variant="scrollable" value={tab} onChange={(ev, val) => setTab(val)}>
            <Tab label="Edit Person" value="edit" />
            <Tab label="Contact Methods" value="contactMethods" />
            <Tab label="Credential" value="credential" />
            <Tab label="Employment" value="employment" />
            <Tab label="Associate" value="associate" />
            <Tab label="Features" value="features" />
            <Tab label="Names" value="names" />
            <Tab label="Vehicle Registrations" value="vehicle" />
            <Tab label="Addresses" value="addresses" />
            <Tab
              label={countOfSops > 0 ? `SOPs (${countOfSops})` : 'SOPs'}
              value="sops"
              className={countOfSops > 0 ? classes.RedTabs : ''}
            />
            <Tab label="Attachments" value="attachments" />
            <Tab label="DNA Samples" value="dna" />
            <Tab label="Photo" value="photo" />
            <Tab label="Related Records" value="relatedRecords" />
            <Tab
              label={countOfBulletin > 0 ? `Bulletins (${countOfBulletin})` : 'Bulletins'}
              value="bulletins"
              className={countOfBulletin > 0 ? classes.RedTabs : ''}
            />
            {/* <Tab label="Coordinates" value="coordinates" /> */}
          </Tabs>
        </Paper>
        {tab === 'edit' && (
          <div className={classes.wrap}>
            <PersonTab personId={ptsPersonID} close={close} editingForm={true} />
          </div>
        )}
        {tab === 'employment' && <Employment ptsPersonID={ptsPersonID} />}
        {tab === 'contactMethods' && <ContactMethods personId={ptsPersonID} />}
        {tab === 'credential' && <Credential personId={ptsPersonID} />}
        {tab === 'associate' && <PersonAssociate personId={ptsPersonID} />}
        {tab === 'features' && <Features ptsPersonID={ptsPersonID} />}
        {tab === 'names' && <Names ptsPersonID={ptsPersonID} />}
        {tab === 'vehicle' && <PersonVehicle personId={ptsPersonID} />}
        {tab === 'addresses' && <Addresses ptsPersonID={ptsPersonID} />}
        {tab === 'sops' && <Sops personId={ptsPersonID} onSOPChange={handleSOPChange} />}
        {tab === 'attachments' && <Attachments type="Person" id={ptsPersonID}  permissions ={permissions}/>}
        {tab === 'dna' && <DnaSamples ptsPersonID={ptsPersonID} />}
        {tab === 'photo' && <Photo ptsPersonID={ptsPersonID} />}
        {tab === 'relatedRecords' && <RelatedRecords ptsPersonID={ptsPersonID} />}
        {tab === 'bulletins' && (
          <Bulletins person={person} onBulletinChange={handleBulletinChange} />
        )}
        {/* {tab === 'parties' && <AddressParties ptsAddressID={ptsAddressID} />} */}
      </div>
    </Dialog>
  );
}

export default connect(null, {
  closeEditPerson,
  handleError,
})(Person);
